import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Support from "./Support/Support";
import Contactus from "./Contactus/Contactus";
import { updateOpenSupport } from "../../redux/features/user-slice";

const ContactSupportModel = () => {
  const { open_support } = useSelector((state) => state.userReducer.value);

  const dispatch = useDispatch();

  const handleCloseSupportModel = () => {
    dispatch(updateOpenSupport({ open_support: false }));
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open_support) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open_support, isVisible]);

  if (!shouldRender) return null;
  return (
    <>
      <div className={`contact-support-model ${isVisible ? "active" : ""}`}>
        {open_support === "support" ? (
          <Support isModel={true} />
        ) : open_support === "contact" ? (
          <Contactus isModel={true} />
        ) : (
          <></>
        )}
      </div>
      {isVisible && (
        <div
          className="support-blur-back"
          onClick={handleCloseSupportModel}
        ></div>
      )}
    </>
  );
};

export default ContactSupportModel;
